module.exports = [
	"background",
	"party leadership",
	"communication",
	"relations with congress",
	"court appointments",
	"handling of economy",
	"luck",
	"ability to compromise",
	"willing to take risks",
	"executive appointments",
	"overall ability",
	"imagination",
	"domestic policy",
	"integrity",
	"executive ability",
	"foreign policy",
	"leadership",
	"intelligence",
	"avoid crucial mistakes",
	"expert view"
];


//////////////////
// WEBPACK FOOTER
// ./components/Presidents/variables.json
// module id = 547
// module chunks = 37